import { removeNonPrintableCharacters } from './removeNonPrintableCharacters';

export const cleanNodeText = (node) => {
  if (node?.object === 'text') {
    const text = removeNonPrintableCharacters(node?.text);
    return node?.set('text', text);
  }
  if (node?.nodes) {
    // Recursively clean all child nodes
    const cleanedNodes = node?.nodes?.map(cleanNodeText);
    return node?.set('nodes', cleanedNodes);
  }
  return node;
};
